import { Link, useParams } from "react-router-dom";
import { insightArticles } from "../content";
import { ArrowIcon } from "../components/Icons";
import Seo from "../components/Seo";
import NotFoundPage from "./NotFoundPage";

export default function ArticlePage() {
  const { slug } = useParams();
  const article = insightArticles.find((candidate) => candidate.slug === slug);

  if (!article) return <NotFoundPage />;

  return (
    <>
      <Seo title={article.title} description={article.summary} />
      <article className="article-page" id="article">
        <header className="article-hero">
          <div>
            <Link className="breadcrumb" to="/insights/articles">Insights / Articles <span>/</span></Link>
            <p className="section-label">{article.category}</p>
            <h1>{article.title}</h1>
            <p className="inner-lead">{article.summary}</p>
            <div className="article-meta"><span>Medein Editorial</span><span>Reviewed July 2026</span><span>6 minute read</span></div>
          </div>
          <img className="article-hero-image" src={article.image} alt={`${article.title} — Medein`} fetchPriority="high" decoding="async" />
        </header>

        <section className="article-takeaways" id="takeaways">
          <p className="section-label">Key takeaways</p>
          <ol>
            {article.takeaways.map((takeaway, index) => <li key={takeaway}><span>{String(index + 1).padStart(2, "0")}</span><strong>{takeaway}</strong></li>)}
          </ol>
        </section>

        <section className="article-body">
          {article.sections.map(([title, text]) => <section key={title}><h2>{title}</h2><p>{text}</p></section>)}
          <aside id="article-evidence">
            <p className="section-label">Evidence and limitations</p>
            <p>This article is a company perspective and public explanatory resource. It does not present clinical guidance, validated universal performance, or a substitute for program-specific evidence review.</p>
          </aside>
        </section>
      </article>

      <section className="detail-cta">
        <div><p className="section-label">Continue the conversation</p><h2>Connect the perspective to a real program.</h2><p>Share the scientific or product question your team is evaluating.</p></div>
        <Link className="button button-light" to="/partnership">Partner With Us <ArrowIcon /></Link>
      </section>
    </>
  );
}
